<div class="modal-header">
    <h4 class="col-10 m-auto font-22 font-weight-600 text-center" [translate]="title">
        {{title | translate}}
    </h4>
    <span aria-hidden="true" aria-label="Close" class="cursor-pointer close-x font-25" (click)="onClose()">×</span>
</div>
